<template>
    <div class="transportation panel">
        <h4 class="mb-3 pb-3 border-bottom-light">Transport</h4>

        <div class="form-group row">
            <div class="col-sm-12 d-flex">
                <label>Include transportation?</label>

                <toggle-button
                    class="ml-auto"
                    v-model="hasTransportation"
                    :labels="{ checked: 'YES', unchecked: 'NO' }">
                </toggle-button>
            </div>
        </div>

        <div v-if="hasTransportation">
            <transport-form @updateFields="updateFields"></transport-form>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import TransportForm from './TransportForm'

    export default {
        data: function() {
            return {
                hasTransportation: false,
            }
        },
        created: function() {
            if (this.getClonedReservation.transport !== undefined && 
                this.getClonedReservation.transport && 
                this.getClonedReservation.transport.transfers !== undefined && 
                this.getClonedReservation.transport.transfers.length > 0) {

                this.hasTransportation = true;
            }
        },
        computed: {
            ...mapGetters([
                'getClonedReservation',
            ]),
        },
        methods: {
            toggleCheckbox: function(e) {
                this.hasTransportation = !this.hasTransportation;
            },
            updateFields: function(data) {
                console.log('Updating transport fields', JSON.stringify(data));
                this.$emit('updateFields', { transport: data });
            }
        },
        components: {
            TransportForm
        }
    }
</script>


// WEBPACK FOOTER //
// Transport.vue?0d904b72